import {useNavigate} from 'react-router-dom';
import {useLayoutEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {PATHS} from 'Routes';
import keycardIcon from 'assets/icons/key-card.svg';
import {useDispenserControls, useKioskoStore} from 'context/kiosko';
import {useBuildNavigationItems, useModalControls, useGuestGroup, usePath} from 'hooks';
import InternalRemoteAccess from '../InternalRemoteAccess';
import {ProgressTaskBar} from 'components/Kiosko/ProgressTaskBar';
import {BoxInfo, Button, NavigationStatus} from '@guestapp/ui';
import {PrintingCardsModal} from 'components/Kiosko/PrintingCardsModal';
import {RegisteredGuestsInfoModal} from 'components/Kiosko/RegisteredGuestsInfoModal';
import styles from './styles.module.css';

function RemoteKeys() {
  const {t} = useTranslation();
  const {guestGroup} = useGuestGroup();
  const printed = useKioskoStore(state => state.cards.printed);
  const pending = useKioskoStore(state => state.cards.pending);
  const pendingGuests =
    (guestGroup?.known_number_of_guests ?? 0) - (guestGroup?.added_number_of_guests ?? 0);
  const {getFullPath} = usePath();
  const {printCard} = useDispenserControls();
  const {getRegistrationPath} = useBuildNavigationItems();
  const {
    isOpen: isOpenRegisteredGuestsInfoModal,
    closeModal: closeRegisteredGuestsInfoModal,
    openModal: openRegisteredGuestsInfoModal,
  } = useModalControls();

  const navigate = useNavigate();
  useLayoutEffect(() => {
    openRegisteredGuestsInfoModal();
  }, [openRegisteredGuestsInfoModal]);

  return (
    <InternalRemoteAccess
      subtitle={t('each_keycard_provides_access_to_your_assigned_areas')}
      isLoading={false}
      title={t('my_key_cards')}
    >
      <div className={styles.container}>
        <div className={styles.progressTaskBarContainer}>
          <ProgressTaskBar
            completed={printed}
            title={t('printed_keycards')}
            icon={<img src={keycardIcon} alt="printed" width={24} height={24} />}
            total={guestGroup?.known_number_of_guests ?? 0}
          />
          <div className={styles.progressTaskBarText}>
            {t('keycard_printed_and_remaining', {
              printed,
              remaining: pending ?? guestGroup?.known_number_of_guests,
            })}
          </div>
        </div>
        <BoxInfo
          text={t('make_sure_the_document_properly_lies_flat')}
          type={NavigationStatus.information}
        />
        {pending > 0 && <Button label={t('print_new_keycard')} onClick={printCard} />}
        <PrintingCardsModal />
        <RegisteredGuestsInfoModal
          isOpen={isOpenRegisteredGuestsInfoModal}
          registeredGuests={guestGroup?.added_number_of_guests}
          onRegisterNext={() => {
            navigate(getFullPath(getRegistrationPath()));
          }}
          onGoHome={() => {
            navigate(getFullPath(PATHS.home));
          }}
          onClose={closeRegisteredGuestsInfoModal}
          pendingGuests={pendingGuests}
        />
      </div>
    </InternalRemoteAccess>
  );
}

export {RemoteKeys};
